import localStorage from '@/configs/localStorage'
import axios from '@/configs/axios'
import router from '@/configs/router'
import store from '@/store/store'

const getToken = () => {
  try {
    return JSON.parse(localStorage.getItem('token'))
  } catch (err) {
    return null
  }
}

const getRefreshToken = () => {
  try {
    return JSON.parse(localStorage.getItem('refresh_token'))
  } catch (err) {
    return null
  }
}

const Auth = {
  saveTokens: (data) => {
    localStorage.setItem('token', JSON.stringify(data.token))
    localStorage.setItem('refresh_token', JSON.stringify(data.refreshToken))
  },
  saveUser: (user) => {
    localStorage.setItem('user', JSON.stringify(user))
  },
  setHeader: (app, token) => {
    axios.defaults.headers.common['Authorization'] = `${token.type} ${token.value}`
  },
  getToken: getToken,
  getRefreshToken: getRefreshToken,
  getUser: (token) => {
    return JSON.parse(localStorage.getItem('user'))
  },
  logout: () => {
    try {
      localStorage.removeItem('token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('user')
      delete axios.defaults.headers.common['Authorization']
      store.commit('users/saveCurrentUser', {})
      router.push({ name: 'home' })
    } catch (err) {
    }
  },
  refreshToken: async () => {
    let token = getToken()
    let refresh = getRefreshToken()
    return axios.get(`${process.env.VUE_APP_API}/auth/refresh-token`, {
      'headers': {
        'Authorization': `${token.type} ${token.value}`,
        'Refresh': `${refresh.type} ${refresh.value}`
      }
    })
  }
}

export default Auth
